module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var terror = Util.clone(value); 
    ; __append("\n\n")
    ;  if (terror.removed) { 
    ; __append("\n\n<b>УДАЛЁН</b>\n\n")
    ;  } else { 
    ; __append("\n<div>\n	<b>")
    ; __append(escapeFn( Glonass.TerrorType.title(terror.type) ))
    ; __append("</b>\n</div>\n")
    ;  if (terror.person) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("Person", {value: terror.person, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (terror.vehicle) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("Vehicle", {value: terror.vehicle, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (terror.comment) { 
    ; __append("\n")
    ; __append(escapeFn( terror.comment ))
    ; __append("\n")
    ;  } else if (mode == "foreign" && native && native.comment) { 
    ; __append("\n<s>комментарий</s>\n")
    ;  } 
    ; __append("\n\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}